
export const PRODUCT_INCREASE = 'product-increase';
export const PRODUCT_DECREASE = 'product-decrease';
export const PRODUCTS_CLEAR = 'products-clear';

